var render, staticRenderFns
import script from "./bind_sub_subjects.vue?vue&type=script&lang=js&"
export * from "./bind_sub_subjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335b736a')) {
      api.createRecord('335b736a', component.options)
    } else {
      api.reload('335b736a', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/budget/budget_subjects/form/bind_sub_subjects.vue"
export default component.exports